import { type EditorState, PluginKey } from '@atlaskit/editor-prosemirror/state';
import { type ReferentialityPluginState } from '../types';

export const pluginKey = new PluginKey<ReferentialityPluginState>('referentialityPlugin');
export const getPluginState = (state: EditorState): ReferentialityPluginState | undefined | null =>
	state && pluginKey.getState(state);
